import { PolicyTemplate } from '@pccr-ifc/pccr-ifc';

export const isRequestArrayPattern = (template: PolicyTemplate) => {
  if (template == null) return undefined;

  const regex = /::\[\{.*?\}\]$/;
  return regex.test(template.request);
};
